import styled from '@emotion/styled'
import * as React from 'react'

import { colors, Text } from 'main/ui'

const ErrorText = styled(Text)`
  color: ${colors.text.error};
`

export default function EmailExistsError() {
  return <ErrorText>Something went wrong! Please try again.</ErrorText>
}
